/** Build WhatsApp deep-link with a professional Creole receipt message. */
import { isKnownClientTransferId } from "@/utils/knownClient";

export function digitsOnly(phone) {
  return String(phone || "").replace(/\D/g, "");
}

/** Normalize to international digits for wa.me (default Haiti 509). */
export function whatsappDigits(phone) {
  let d = digitsOnly(phone);
  if (!d) return "";
  if (d.startsWith("00")) d = d.slice(2);
  if (d.length === 8) d = `509${d}`;
  return d;
}

export function trackingUrl(transferId, origin = typeof window !== "undefined" ? window.location.origin : "") {
  const base = (origin || "https://www.tgshaiti.com").replace(/\/+$/, "");
  return `${base}/?id=${encodeURIComponent(transferId)}`;
}

/** Full receipt message — for WhatsApp kliyan ki voye → kliyan k ap resevwa. */
export function buildSenderReceiptMessage({
  transferId,
  senderName,
  senderWhatsapp,
  clientName,
  clientWhatsapp,
  clientAddress,
  netAmount,
  serviceFee,
  totalAmount,
  trackUrl,
  company = "Takara Global Services (TGS)",
  knownClient = false,
}) {
  const fmt = (n) => {
    const x = typeof n === "number" ? n : parseFloat(n);
    return Number.isFinite(x) ? x.toFixed(2) : String(n ?? "0");
  };
  return (
    `Bonjou 👋\n\n` +
    `🧾 *Resi transfè Zelle* — *${company}*.\n\n` +
    `• No# Transfè: *${transferId}*\n` +
    (senderName ? `• Moun ki voye: *${senderName}*\n` : "") +
    (senderWhatsapp ? `• WhatsApp kliyan: ${senderWhatsapp}\n` : "") +
    `• Moun k ap resevwa: *${clientName || "—"}*\n` +
    (clientWhatsapp ? `• WhatsApp benefisyè: ${clientWhatsapp}\n` : "") +
    (clientAddress ? `• Kote pou pase pran lajan an:\n${clientAddress}\n` : "") +
    `• Montan li ap jwenn: *$${fmt(netAmount)} USD*\n` +
    `• Frè sèvis: *$${fmt(serviceFee)} USD*\n` +
    `• Montan total: *$${fmt(totalAmount)} USD*\n` +
    `\n📎 *Resi vizyèl* — tanpri *tache foto/PDF a* nan mesaj WhatsApp sa a.\n` +
    `\n📌 *Enstriksyon:*\n` +
    `⚠️ TGS *pa bay sèvis transfè an liy*.\n` +
    ((knownClient || isKnownClientTransferId(transferId))
      ? `Moun sa a nou konnen. Li dwe konnen No# (*${transferId}*) epi *pase pran* kòb la nan *adrès fizik* ki anwo a. Pa bezwen pyès idantite.\n`
      : `Moun k ap resevwa a dwe konnen No# (*${transferId}*), pote yon *pyès idantite*, epi *pase pran* kòb la nan *adrès fizik* ki anwo a.\n`) +
    `\n🔗 Swivi: ${trackUrl}\n\n` +
    `Mèsi paske w chwazi TGS 🙏\n` +
    `Takara Global Services`
  );
}

/** @deprecated alias — same full receipt message */
export const buildReceiptWhatsAppMessage = buildSenderReceiptMessage;

/** Default WhatsApp assist button prefill (Julie / site support). */
export const DEFAULT_WA_ASSIST_MESSAGE =
  "Bonjou, m bezwen asistans sou yon transfè Takara Global Services (TGS).";

export function whatsappSendUrl(phone, text) {
  const d = whatsappDigits(phone);
  if (!d) return null;
  return `https://wa.me/${d}?text=${encodeURIComponent(text)}`;
}
